import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="border-y border-weathered-steel bg-charcoal-green-ink p-7 text-mineral-gray md:p-12 lg:p-16">
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </GroundSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
